// extracted by mini-css-extract-plugin
export default {"loader":"VCmzq2sv","small":"hjAvZ5AX","white":"iDzlK7A6"};